import axios from 'axios';

export default {
    namespaced: true,

    state: {
        payment: {},
        tennisIntegrityUnitStatus: false,
        loading: false,
        loadingError: null,
        associatedPlayersForAgent: null,
        annualFormValidation: null,
        isUserEnableToSignTheAnnualForm: false,
    },

    getters: {
        payment: (state) => state.payment,
        tennisIntegrityUnitStatus: (state) => state.tennisIntegrityUnitStatus,
        loading: (state) => state.loading,
        loadingError: (state) => state.loadingError,
        associatedPlayersForAgent: (state) => state.associatedPlayersForAgent,
        annualFormValidation: (state) => state.annualFormValidation,
        isUserEnableToSignTheAnnualForm: (state) => state.isUserEnableToSignTheAnnualForm,
    },

    mutations: {
        setPayment(state, data) {
            state.payment = data;
        },

        setTennisIntegrityUnitStatus(state, data) {
            state.tennisIntegrityUnitStatus = data;
        },

        setPlayersAssociatedToAgent(state, data) {
            state.associatedPlayersForAgent = data
        },

        setAnnualFormValidation(state, data) {
            state.annualFormValidation = data;
        },

        startLoading(state) {
            state.loading = true;
        },

        stopLoading(state) {
            state.loading = false;
        },

        setLoadingError(state, error) {
            state.loadingError = error;
        },

        clearLoadingError(state) {
            state.loadingError = null;
        },

        setIsUserEnableToSignTheAnnualForm(state, data) {
            state.isUserEnableToSignTheAnnualForm = data;
        }
    },

    actions: {
        async retrievePaymentInformation(context, options = {}) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_API_URL}/access/PaymentInformation/${options.playerIdentifier}`);
                context.commit('stopLoading');
                context.commit('clearLoadingError');
                context.commit('setPayment', result.data);
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('stopLoading');
                context.commit('setLoadingError', error);
                return Promise.reject(error);
            }
        },
        async retrieveTennisIntegrityUnitStatus(context, options = {}) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_API_URL}/access/TennisIntegrityUnitInformationForPlayer/${options.playerIdentifier}`);
                context.commit('stopLoading');
                context.commit('clearLoadingError');
                context.commit('setTennisIntegrityUnitStatus', result.data);
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('stopLoading');
                context.commit('setLoadingError', error);
                return Promise.reject(error);
            }
        },
        async retrievePlayersAssociatedToAgent(context, options = {}) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_API_URL}/Player/ByAgentEmail/${options.userEmail}`);
                context.commit('stopLoading');
                context.commit('clearLoadingError');
                context.commit('setPlayersAssociatedToAgent', result.data);
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('stopLoading');
                context.commit('setLoadingError', error);
                return Promise.reject(error);
            }
        },
        async retrieveAnnualFormValidation(context, options = {}) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_API_URL}/playerconsentform/${options.playerIdentifier}/${options.playerEmail}/annual-form`);
                context.commit('stopLoading');
                context.commit('clearLoadingError');
                context.commit('setAnnualFormValidation', result.data);
                console.debug(result);
                if (result.status === 400 && result.data.code === "PlayerConsentForm.PlayerNotIsEnableToSign") {
                    context.commit('setIsUserEnableToSignTheAnnualForm', false);
                } else {
                    context.commit('setIsUserEnableToSignTheAnnualForm', true);
                }
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('stopLoading');
                if(error.response && error.response.status === 400){
                    if(error.response.data.code === "PlayerConsentForm.PlayerNotIsEnableToSign")
                        context.commit('setIsUserEnableToSignTheAnnualForm', false);
                    else
                        context.commit('setIsUserEnableToSignTheAnnualForm', true);
                    return Promise.resolve(error.response.data);
                }
                // Handle only the 500 status code here
                context.commit('setLoadingError', error);
                return Promise.reject(error);
            }
        }
    },
};
